<script setup lang="ts">
import { useGlobalLoadingStore } from "@/stores/AppStartUp/GlobalLoadingStore";

const globaleLoadingStore = useGlobalLoadingStore();
</script>

<template>
    <div
        v-if="globaleLoadingStore.isLoading"
        class="fixed h-screen w-screen d-flex justify-center align-center bg-black"
    >
        <div>
            <v-progress-circular
                indeterminate
                color="primary"
            />
        </div>
    </div>
</template>

